import cx from 'classnames';
import { asset } from '../../services/assetResolverService';
import PatronLabel from '../patreon/patronLabel';
import { TPatronLevel } from '../../../common/patron';
import { Component } from 'react';

export type TProfileMastheadProps = {
  bannerAssetName: string;
  target?: any;
  highlights?: any;
  children?: any;
  bannerTransition?: boolean;
  isTournamentProfile?: boolean;
  faction?: string;
  watermark?: boolean;
  className?: string;
  patronLevel?: TPatronLevel;
  showPatronLabel?: boolean;
  isAnimated?: boolean;
};

export class ProfileMasthead extends Component<any, any> {
  public render() {
    const showPatronLabel = this.props.showPatronLabel && this.props.patronLevel?.level > 2;

    const bannerImageUrl = this.props.forceBannerUrl || this.getBannerAssetUrl(false);
    const bannerVideoUrl = this.props.forceBannerUrl || this.getBannerAssetUrl(true);

    const masthead = (
      <div
        className={cx('rio-background--header', this.props.className)}
        style={{
          position: 'relative',
          // Use CSS background for non-animated mastheads
          backgroundImage: !this.props.isAnimated
            ? (this.props.watermark ? 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), ' : '') +
              `url(${bannerImageUrl})`
            : undefined,
          // Guild pages set --rio-guild-accent-legible from the guild's brand
          // color; when unset (character pages, colorless guilds) this falls
          // back to the faction inset ring, unchanged.
          ...(this.props.faction
            ? {
                boxShadow: `inset 0px 0px 2px 0px var(--rio-guild-accent-legible, ${
                  this.props.faction === 'horde' ? '#e02929' : '#69f'
                })`
              }
            : {})
        }}
      >
        {/* For animated mastheads, use video with poster attribute for optimal LCP.
            The poster shows immediately for fast LCP, then video autoplays over it. */}
        {this.props.isAnimated && (
          <video
            poster={bannerImageUrl}
            src={bannerVideoUrl}
            autoPlay
            loop
            muted
            playsInline
            style={{
              objectFit: 'cover',
              objectPosition: 'top left',
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0
            }}
          />
        )}
        <div className={cx({ 'rio-characterbanner-padding': !this.props.watermark })}>
          <div className="slds-grid slds-wrap slds-grid--vertical-align-center rio-masthead--content-top">
            <h1
              className={cx(
                'slds-col',
                'slds-grid',
                'rio-flex-justify-center--max-small',
                'rio-p-left-xs-mobi--none',
                'rio-p-left-mobi--small'
              )}
            >
              {this.props.target}
            </h1>
            {this.props.highlights}
            {this.props.watermark && (
              <div className="slds-text-align--center slds-col">
                <img src={asset('/images/brand/Mark_FullColor.png')} width={50} height={80} />
              </div>
            )}
          </div>
        </div>
        {showPatronLabel && (
          <div style={{ position: 'absolute', bottom: '15px', right: '15px' }}>
            <PatronLabel {...this.props.patronLevel} className="slds-p-horizontal--small" />
          </div>
        )}
        {this.props.children}
      </div>
    );

    return masthead;
  }

  private getBannerAssetUrl(useAnimation: boolean) {
    if (useAnimation) {
      return asset(`/images/profile/masthead_backdrops/animated/${this.props.bannerAssetName}.mp4`);
    }
    return asset(`/images/profile/masthead_backdrops/v2/${this.props.bannerAssetName}.jpg`);
  }
}
